import { render, staticRenderFns } from "./ObiTable.vue?vue&type=template&id=595e5422&scoped=true&"
import script from "./ObiTable.vue?vue&type=script&lang=js&"
export * from "./ObiTable.vue?vue&type=script&lang=js&"
import style0 from "./ObiTable.vue?vue&type=style&index=0&id=595e5422&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595e5422",
  null
  
)

export default component.exports